import { useEffect, useState } from 'react'
import { Skeleton, Text } from '@chakra-ui/react'

import { CustomFormCommonEntityFilter } from 'components/tools/CustomForm/components/Viewer/components/CustomFormViewerQuestion/components/CustomFormViewerQuestionSelection/components/CustomFormEntitiesQuestions/components/CustomFormCommonEntitySelectionDrawer/types'
import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'
import CustomFormCommonEntityCard from 'components/tools/CustomForm/commonComponents/CustomFormCommonEntityCard'
import getEntityOnCustomForm from './services/getEntityOnCustomForm'

type Props = {
  entityKey: string
}

export default function CustomFormAnswerCommonEntity({ entityKey }: Props) {
  const [loadingEntity, setLoadingEntity] = useState<boolean>(false)
  const [entity, setEntity] = useState<CustomFormCommonEntityFilter>({})

  const { answer } = useCustomFormAnswer()

  const answerValue = answer.answer ? answer.answer[0] : ''

  const formatEntityKey = entityKey === 'organizational-unit' ? 'org_unit' : entityKey

  const entityId: string = answerValue

  async function getEntity() {
    setLoadingEntity(true)
    const response = await getEntityOnCustomForm({ entityKey, id: entityId })
    if (response?.header?.success) {
      const entityFromAPI = response?.body?.[formatEntityKey.replace('-', '_')]
      setEntity(entityFromAPI)
    }
    setLoadingEntity(false)
  }

  useEffect(() => {
    if (answerValue) getEntity()
  }, [answerValue])

  if (!answerValue) {
    return (
      <Text variant="secondary" fontStyle="italic">
        Sem resposta
      </Text>
    )
  }

  return (
    <Skeleton isLoaded={!loadingEntity}>
      <CustomFormCommonEntityCard borderWidth="1px" borderColor="borderColor" entity={entity} />
    </Skeleton>
  )
}
